(function ($) {
    $(window).load(function () {

        window.popup = {

            template: '<div id="popup">\n' +
                '<div class="wrap">\n' +
                '<div class="close"></div>\n' +
                '<div class="content"></div>\n' +
                '</div>\n' +
                '</div>',

            init: function ($args) {

                this.$target = $($args.target);

                this.$popup = $(this.template);
                this.$wrap = $('.wrap', this.$popup);
                this.$close = $('.close', this.$popup);

                this.$header = $('#header-site');
            },

            initStatus: function () {

                if (this.$popup.hasClass('is-hidden')) {
                    $('html').removeClass('is-popup-visible');
                } else {
                    $('html').addClass('is-popup-visible');
                }
            },

            initPosition: function () {
                let scrollTop = $(window).scrollTop();
                let windowHeight = $(window).outerHeight();
                let popupHeight = this.$wrap.outerHeight();

                let top = ((windowHeight - popupHeight) / 2) + scrollTop;
                top = (top < 0) ? 30 : top;

                this.$popup.css({
                    'margin-top': top
                })
            },

            initActions: function () {

                let self = this;

                this.$close.on('click', function () {
                    self.close();
                });
            },

            setContent: function ($content) {
                this.$content = $content;
                this.$popup.find('.content').empty().append($content);
            },

            setAttrs: function (attrs) {

                if (attrs.class !== undefined) {
                    this.$popup.addClass(attrs.class);
                }
            },

            show: function () {
                this.$popup.removeClass('is-hidden').appendTo('body').show();
                this.initStatus();
                this.initPosition();
                this.initActions();
            },

            close: function () {

                let self = this;

                this.$popup.fadeOut(300, function () {
                    self.$popup.addClass('is-hidden');
                    console.log(self.$target);
                    self.$target.empty().append(self.$content);
                    self.initStatus();
                });
            },

        };

    });
})(jQuery);